import React, { memo } from "react";
import { vritix_logo } from "../../assets/images/tms-image-list";
import "../../App.scss";
const TmsLoading = () => {
  return (
    <div className="loading-logo">
      {" "}
      <img src={vritix_logo} className="tms-login-logo" height="150px" />
      <p>Loading...</p>
    </div>
  );
};

export default memo(TmsLoading);
